<template>
  <div class="rp-roles-tip">
    <r-icon
      name="lock"
      :size="24"
    />
    <r-text>
      {{ tip }}
    </r-text>
  </div>
</template>

<script>
export default {
  props: {
    tip: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.rp-roles-tip {
  position: relative;
  display: flex;
  align-items: center;
  align-self: flex-start;
  border-radius: var(--border-radius);
  background-color: var(--accent_selected);
  overflow: hidden;
  padding: 8px;
  width: 100%;
  margin-bottom: 16px;

  .r-icon {
    margin-right: 8px;
  }
}
</style>
